import React from "react";
import { Outlet, Link } from "react-router-dom";
import CookieConsent from "react-cookie-consent";

const Layout = () => {
  const get_sign_in = () => {
    const url = `${process.env.REACT_APP_OPENID_SIGNIN_URL}`;
    window.open(url, "_self");
  };
  return (
    <div>
      <nav
        className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light site-navbar-target"
        id="ftco-navbar"
      >
        <div className="container">
          <a className="navbar-brand" href="/">
            <img
              style={{
                height: "15px",
                padding: "0 10px",
              }}
              alt="Alpis Studio"
              src={`${process.env.PUBLIC_URL}/logo_fundo_branco.svg`}
            />
          </a>
          <button
            className="navbar-toggler js-fh5co-nav-toggle fh5co-nav-toggle"
            type="button"
            data-toggle="collapse"
            data-target="#ftco-nav"
            aria-controls="ftco-nav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="oi oi-menu" /> Menu
          </button>
          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav nav ml-auto">
              <li className="nav-item">
                <a
                  href="https://www.alpisstudio.com/#home-section"
                  className="nav-link"
                >
                  <span>Home</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="https://www.alpisstudio.com/#services-section"
                  className="nav-link"
                >
                  <span>Recursos</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  href="https://www.alpisstudio.com/#about-section"
                  className="nav-link"
                >
                  <span>Sobre</span>
                </a>
              </li>
              {/* <li className="nav-item"><a href={process.env.REACT_APP_ALPISLAB_APPLICATION} className="nav-link"><span>Login</span></a></li> */}
            </ul>

            <ul className="navbar-nav justify-content-end ml-auto">
              <li className="nav-item">
                <button
                  className="btn btn-primary btn-outline-primary my-2 my-sm-0"
                  type="submit"
                  onClick={() => get_sign_in()}
                >
                  Login
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <Outlet />

      <CookieConsent
        location="bottom"
        buttonText="Aceitar"
        declineButtonText="Recusar"
        cookieName="cookielawinfo-advertisement"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        declineButtonStyle={{ fontSize: "13px" }}
        expires={150}
        enableDeclineButton
      >
        Este site utiliza cookies para melhorar a experiência de navegação
        <br />
        <div style={{ lineHeight: "1", textAlign: "justify" }}>
          <span style={{ fontSize: "10px" }}>
            {" "}
            Este site usa cookies para melhorar sua experiência enquanto você
            navega pelo site. Destes, os cookies categorizados como necessários
            são armazenados no seu navegador, pois são essenciais para o
            funcionamento das funcionalidades básicas do site. Também usamos
            cookies de terceiros que nos ajudam a analisar e entender como você
            usa este site. Esses cookies poderão ser armazenados no seu
            navegador. Ao utilizar nossos serviços, você concorda com tal
            monitoramento.{" "}
          </span>
          <p>
            <Link target="_blank" to="/privacy-overview">
              Política de privacidade
            </Link>{" "}
            e{" "}
            <Link target="_blank" to="/service-terms">
              Termos de Uso
            </Link>
          </p>
        </div>
      </CookieConsent>

      <footer className="ftco-footer ftco-section" id="about-section">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md">
              <div className="ftco-footer-widget mb-4">
                <h2 className="ftco-heading-2">Sobre o Alpis Studio</h2>
                <p>
                  Nossa missão é prover ao investidor ferramentas e facilidades
                  para acompanhamento do mercado financeiro, com enfase e foco
                  no mercado opções.
                </p>
                <ul className="ftco-footer-social list-unstyled float-md-left float-lft mt-5">
                  <li className="ftco-animate">
                    <a href="#te">
                      <span className="icon-twitter" />
                    </a>
                  </li>
                  <li className="ftco-animate">
                    <a href="#te">
                      <span className="icon-facebook" />
                    </a>
                  </li>
                  <li className="ftco-animate">
                    <a href="#te">
                      <span className="icon-instagram" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md">
              <div className="ftco-footer-widget mb-4">
                <h2 className="ftco-heading-2">Contato</h2>
                <div className="block-23 mb-3">
                  <ul>
                    <li>
                      <span className="icon icon-map-marker" />
                      <span className="text">São Paulo - Brasil</span>
                    </li>
                    <li>
                      <a href="#te">
                        <span className="icon icon-envelope" />
                        <span className="text">info@alpisstudio.com</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <p>
                Copyright © Todos os direitos reservados |{" "}
                <Link target="_blank" to="/service-terms">
                  Termos de Uso
                </Link>{" "}
                |{" "}
                <Link target="_blank" to="/privacy-overview">
                  Política de privacidade
                </Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
